module.exports = __webpack_public_path__ + "static/icon-pledge-1-9fd39e4f82600cec9ad1b1b5ab014890.svg";